/*=========================================================================================
  File Name: module-licenseinfo.js
  Description: LicenseInfo Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-licenseinfo-state';
import mutations from './module-licenseinfo-mutations';
import actions from './module-licenseinfo-actions';
import getters from './module-licenseinfo-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
